import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'end',
  justifyContent: 'space-between',
};

export const cardContent: SxStyle = {
  width: '100%',
};

export const boxPlan: SxStyle = {
  flex: '1 1 0%',
  minWidth: 0,
  maxWidth: '100%',
  height: '100%',
  display: 'flex',
};
